import { render, staticRenderFns } from "./DailySalesRegisterReportExcel.vue?vue&type=template&id=4225f6cc&"
import script from "./DailySalesRegisterReportExcel.vue?vue&type=script&setup=true&lang=js&"
export * from "./DailySalesRegisterReportExcel.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports